import axios, { type AxiosRequestConfig } from 'axios';
import { isEmpty, isNil } from 'lodash';
import { API_BASE_URL } from '../config/apiUrl';
import { roleListProps } from './GlobalContextProvider';

export interface ApiRequestOptions {
   basePath?: string;
   endpoint: string;
   body?: string | any;
   params?: object;
   method: 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH';
   headers?: Record<string, string>;
   includeToken?: boolean;
   responseType?: 'arraybuffer' | 'blob' | 'document' | 'json' | 'text' | 'stream';
}

const defaultHeaders: Record<string, string> = {
   'Content-Type': 'application/json',
   Accept: 'application/json',
};

export const apiRequest = async (props: ApiRequestOptions): Promise<any> => {
   const includeTokenVerify = () => {
      if (isNil(props.includeToken)) {
         return false;
      }
      return true;
   };


   const mergedHeaders = props.headers ? { ...props.headers } : defaultHeaders;
   if (getaccessToken() && includeTokenVerify()) {
      mergedHeaders.Authorization = `Bearer ${getaccessToken()}`;
   }else{
      delete mergedHeaders?.Authorization;
   }


   const config: AxiosRequestConfig = {
      url: `${props.basePath ?? API_BASE_URL}${props.endpoint}`,
      method: props.method,
      headers: mergedHeaders,
      params: props.params,
      data: props.body,
      responseType: props?.responseType || 'json'
   };

   try {
      const response = await axios(config);
      return response;
   } catch (error) {
      throw error;
   }
};

export const getaccessToken = (): string | null => {
   return sessionStorage.getItem('user-token');
};


export const checkAuthToken = (): boolean => {
   if (isNil(getaccessToken()) || isEmpty(getaccessToken()) || getaccessToken() === 'undefined') {
      return false;
   } else {
      return true;
   }
};

export const getUserName = (): string | null => {
   return sessionStorage.getItem('username');
};

export const getUserRoleId = () => {
   return sessionStorage.getItem('userRoleId');
}

export const getUserRoles = (): roleListProps[] | null => {
   const rolesString = sessionStorage.getItem('user-roles');
 
   if (!rolesString) {
     return null;
   }
 
   const roles = JSON.parse(rolesString);
   return roles;
 };
 
 export const checkUserRoles = (): boolean => {
   const userRoles = getUserRoles();
 
   return (
     !!userRoles &&
     userRoles.length > 0
   );
 };
 
 export const getUserRolesList = (): roleListProps[] | [] => {
   const userRoles = getUserRoles();
 
   if (checkUserRoles() && !isNil(userRoles)) {
     return userRoles;
   } else {
     return [];
   }
 };

export const authService = {
   isAuthenticated: () => {
      return checkAuthToken();
   },
   getUserRoles: () => {
      return getUserRolesList();
   },
};

export const getUserSelectedRole = (): string | null => {
   return sessionStorage.getItem('selectedRole');
};

export const getUserID = () : string | null => {
   return sessionStorage.getItem('userID');
};

export const getUserDetails = (): string | null => {
   return sessionStorage.getItem('name')
}
// errorHandler.ts

export function catchErrorMessageHandler(err: any): string {
   let ErrorMessage: string = "";

   if (!isNil(err.response)) {
      const data = err.response.data;

      switch (true) {
         case !isNil(data.detailedErrorMessage):
            ErrorMessage = data.detailedErrorMessage;
            break;
         case !isNil(data.errorMessage):
            ErrorMessage = data.errorMessage;
            break;
         case !isNil(data.errorCode):
            ErrorMessage = `${data.errorCode} ${data.status}`;
            break;
         case !isNil(data.detail):
            ErrorMessage = `${data.detail} ${data.status}`;
            break;
         case !isNil(data.error):
            ErrorMessage = `${data.error} ${data.status}`;
            break;
         default:
            ErrorMessage = err.message;
      }
   } else {
      ErrorMessage = err.message;
   }

   return ErrorMessage;
}

export const getDevoteeId = (): any | null => {
   return {
      userId:sessionStorage.getItem('devoteeID'),
      fullName:sessionStorage.getItem('devoteeFullname'),
      dateOfBirth:sessionStorage.getItem('devoteeDob'),
      preferedLangu: sessionStorage.getItem('planguage'),
      nakshatram: sessionStorage.getItem('nakshatram'),
      gothram:sessionStorage.getItem('gothram'),
      address:sessionStorage.getItem('address'),
      city:sessionStorage.getItem('city'),
      state:sessionStorage.getItem('state'),
      zipcode:sessionStorage.getItem('zipcode'),
      country:sessionStorage.getItem('country'),
      homephone:sessionStorage.getItem('home'),
      workphone:sessionStorage.getItem('work'),
      dateofregistration: sessionStorage.getItem('registratiion'),
      access:sessionStorage.getItem('access'),
      updateDate: sessionStorage.getItem('updatedate')
   }
}

export const validateEmail = (email:any) => {
   if (typeof email !== 'string') {
       return "Email must be a valid string.";
   } else if (email.length < 6) {
       return "Email must be at least 6 characters long.";
   } else if (email.length >= 64) {
       return "Email must be less than 64 characters long.";
   } else if (!email.includes("@")) {
       return "Please Enter Valid Email";
   } else {
       return "";
   }
};

export function formatWeekday(date: Date): string {
   const options: Intl.DateTimeFormatOptions = { weekday: 'long' };
   return date.toLocaleDateString('en-US', options);
}

export function displayDateFormat(date: Date): string {
   const day = date?.getDate();
   const month = date?.getMonth() + 1;
   const year = date?.getFullYear();

   const formattedDay = day < 10 ? `0${day}` : day;
   const formattedMonth = month < 10 ? `0${month}` : month;

   return `${formattedMonth}/${formattedDay}/${year}`;
}

export function displayDateTimeFormat(date: Date): string {
   const day = date?.getDate();
   const month = date?.getMonth() + 1;
   const year = date?.getFullYear();

   const hours = date?.getHours();
   const minutes = date?.getMinutes();
   const seconds = date?.getSeconds();
   const ampm = hours! >= 12 ? 'PM' : 'AM';
   const formattedHours = hours! % 12 || 12;

   const formattedDay = day! < 10 ? `0${day}` : day;
   const formattedMonth = month! < 10 ? `0${month}` : month;
   const formattedHours12 = formattedHours < 10 ? `0${formattedHours}` : formattedHours;
   const formattedMinutes = minutes! < 10 ? `0${minutes}` : minutes;
   const formattedSeconds = seconds! < 10 ? `0${seconds}` : seconds;

   return `${formattedMonth}/${formattedDay}/${year} ${formattedHours12}:${formattedMinutes}:${formattedSeconds} ${ampm}`;
}

export const calculateOffsetDate = (date: Date, days = 6) => {
   const newDate = new Date(date);
   newDate.setDate(date.getDate() + days);
   return newDate;
};

export function isPastDate(dateString: string) {
  const givenDate = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset to start of the day
  return givenDate < today; // True if given date is earlier than today
}

export  // Function to get the day of the week as a string
const getDayOfWeek = (date: Date): string => {
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  return daysOfWeek[date.getDay()];
};

export function getDatesBetween(startDateStr: Date | string, endDateStr: Date | string) {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  // Reset hours, minutes, seconds, and milliseconds
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  const dates: { date: string; day: string }[] = [];

  let currentDate = new Date(startDate);

  while (currentDate <= endDate) {

    dates.push({
      date: displayDateFormat(currentDate),
      day: getDayOfWeek(currentDate),
    });

    // Increment the date by one day
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
}

// Function to parse time in "hh:mm AM/PM" format and return total minutes from midnight
export function timeToMinutes(time: string): number {
   const [timePart, period] = time.split(" "); // Split time and AM/PM part
   const [hours, minutes] = timePart.split(":").map(Number); // Split hours and minutes and convert to numbers
   let totalMinutes = hours * 60 + minutes; // Convert hours to minutes and add them
 
   // Adjust if time is PM and not 12 PM
   if (period === "PM" && hours < 12) {
     totalMinutes += 12 * 60; // Add 12 hours for PM times
   } else if (period === "AM" && hours === 12) {
     totalMinutes -= 12 * 60; // Adjust for 12 AM (midnight)
   }
 
   return totalMinutes;
 }
 
 // Function to calculate the duration in minutes between two times
 export function calculateDuration(startTime: string, endTime: string): number {
   const startMinutes = timeToMinutes(startTime); // Convert start time to minutes
   const endMinutes = timeToMinutes(endTime); // Convert end time to minutes
 
   // Calculate the duration by subtracting start minutes from end minutes
   return endMinutes - startMinutes;
 }

 export function separateDateAndTime(dateTimeStr: string) {
   const [datePart, timePart] = dateTimeStr.split(" "); // Separate date and time

   // Convert the date to a more standard format, if needed
   const [month, day, year] = datePart.split("-");
   const formattedDate = `${year}-${month}-${day}`; // For ISO date format (YYYY-MM-DD)

   const date = new Date(`${formattedDate}T${timePart}`); // Convert to Date object

   // Format the date
   const dateFormatter = new Intl.DateTimeFormat("en-US", {
     year: "numeric",
     month: "2-digit",
     day: "2-digit",
   });

   // Format the time with AM/PM
   const timeFormatter = new Intl.DateTimeFormat("en-US", {
     hour: "numeric",
     minute: "numeric",
     hour12: true, // For 12-hour format with AM/PM
   });

   const formattedTime = timeFormatter.format(date);
   const formattedDateString = dateFormatter.format(date);

   return {
     date: formattedDateString,
     time: formattedTime,
   };
 }

 export const allBrowserDateCompatability = (date: any) => {
   return date?.replaceAll("-","/")
 }

 export const generateYearObject = (
   startYear: number
 ): { label: string; value: string }[] => {
   const currentYear = new Date().getFullYear();
   const yearsArray: { label: string; value: string }[] = [];

   for (let year = startYear; year <= currentYear; year++) {
     const yearString = year.toString();
     const yearObject: { label: string; value: string } = {
       label: yearString,
       value: yearString,
     };
     yearsArray.push(yearObject);
   }

   return yearsArray;
 };

 export const getNextMonthDate = (date: Date): Date => {
   const currentMonth = date.getMonth(); // getMonth() returns 0-11
   const nextMonth = currentMonth + 1;

   const nextMonthDate = new Date(date);
   nextMonthDate.setMonth(nextMonth);

   // Handle year rollover if the next month is January
   if (nextMonthDate.getMonth() !== nextMonth % 12) {
     nextMonthDate.setMonth(nextMonth % 12);
     nextMonthDate.setFullYear(date.getFullYear() + 1);
   }

   return nextMonthDate;
 };

 export const sortDataByDateAndTime = (data: any) => {
   return data?.sort((a: any, b: any) => {
     const dateA = new Date(`${a?.date} ${a?.startTime}`);
     const dateB = new Date(`${b?.date} ${b?.startTime}`);

     if (dateA < dateB) return -1;
     if (dateA > dateB) return 1;

     const startA = new Date(`${a?.date} ${a?.startTime}`);
     const startB = new Date(`${b?.date} ${b?.startTime}`);

     if (startA < startB) return -1;
     if (startA > startB) return 1;

     const endA = new Date(`${a?.date} ${a?.endTime}`);
     const endB = new Date(`${b?.date} ${b?.endTime}`);

     if (endA < endB) return -1;
     if (endA > endB) return 1;

     return 0;
   });
 };

